<wl-card [showHeading]="false">
    <div class="advancedFilter">
        <mat-card-actions class="advancedFilterContainer m-0 w-full" [class.center-single]="showOnlyState">
            <div class="select-container">
                <mat-form-field appearance="outline">
                    <mat-label>Select State</mat-label>
                    <mat-select  [(ngModel)]="selectedState" (ngModelChange)="selectState(); setSessionStorage();">
                        <mat-option *ngFor="let state of states" [value]="state.code">{{state.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="select-container" *ngIf="!showOnlyStateAndDate && !showOnlyState">
                <mat-form-field appearance="outline">
                    <mat-label>Select Zone</mat-label>
                    <mat-select  [(ngModel)]="selectedZone" (ngModelChange)="selectZone()" [disabled]="isZoneDropdownDisabled()">
                        <mat-option *ngFor="let zone of zones" [value]="zone.code">{{zone.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="select-container" *ngIf="!showOnlyStateAndDate && !showOnlyState">
                <mat-form-field appearance="outline">
                    <mat-label>Select Regional Office</mat-label>
                    <mat-select  [(ngModel)]="selectedRegion" (ngModelChange)="selectRegion()" [disabled]="isRegionDropdownDisabled()">
                        <mat-option *ngFor="let region of regions" [value]="region.code">{{region.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="select-container" *ngIf="!showOnlyStateAndDate && !showOnlyState">
                <mat-form-field appearance="outline">
                    <mat-label>Select Branch</mat-label>
                    <mat-select  [(ngModel)]="selectedBranch" (ngModelChange)="selectBranch()" [disabled]="isBranchDropdownDisabled()">
                        <mat-option *ngFor="let branch of branches" [value]="branch.code">{{branch.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="!showOnlyState">
                <date-range-filter (onOptionChange)="onDateRangeChange($event)"></date-range-filter>
                <div class="checkboxContainer" *ngIf="isDashboard">
                    <label>Created<input type="checkbox" [(ngModel)]="createdValue" (change)="onCheckboxChange('created')" #created /></label>
                    <label class="ml-1rem">Sanctioned<input type="checkbox" [(ngModel)]="sanctionedValue" (change)="onCheckboxChange('sanctioned')" #sanctioned /></label>
                </div>
            </div>
        </mat-card-actions>
        <button class="mr-2rem mybutton"
            [disabled]="isButtonDisabled() || (createdValue=='' && sanctionedValue=='' && isDashboard) || (disableSubmitInitially && isDashboard)"
            (click)="submitForm()">Submit</button>
    </div>
</wl-card>
